export default {"src":"/_next/static/media/icon-farmhouseDetached.b270a9b3.svg","height":21,"width":29,"blurWidth":0,"blurHeight":0};